/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EsercenteCancellazioneRiepilogoDTO { 
    rendicontazioni_da_inviare?: number;
    cassieri_coinvolti?: number;
}

